import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=19614668&"
import script from "./Share.ts?vue&type=script&lang=ts&"
export * from "./Share.ts?vue&type=script&lang=ts&"
import style0 from "./Share.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports